module.exports = __webpack_public_path__ + "img/RandallWilliams.62c20802.jpg";